<template>
  <section id="card-text-alignment">
    <h3 class="mt-3 mb-2">
      Edite sua Automação
    </h3>
    <h5 class="mt-3 mb-2">
      Nome da sua automação: {{ groupName }}
    </h5>

    <b-row>
      <b-card>
        <b-col md="10">
          <app-timeline>
            <app-timeline-item
              title="Trigger"
              subtitle="All milestones are completed"
              time="few minutes ago"
              variant="success"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <h6>Gatilho inicial</h6>
              </div>
              <p>Ativar o fluxo quando houver um pedido com status:</p>
              <b-form-group>
                <v-select
                  v-model="selected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="status"
                  :options="statuses"
                />
              </b-form-group>
            </app-timeline-item>

            <app-timeline-item
              title="Aguardar 2 dias"
            />

            <app-timeline-item
              title="Se enviar mensagem"
              subtitle="Obrigado pela sua compra! Por favor, não esqueça de avaliar seu pedido através deste link"
            />

            <app-timeline-item
              title="Fim da Automação"
              subtitle="A automação termina aqui."
              variant="secondary"
            />
          </app-timeline>
        </b-col>
      </b-card>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BButton, BModal, VBModal, BForm, BFormGroup, BFormTextarea, BFormInput, BFormRadio,
  BFormFile,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { kFormatter } from '@core/utils/filter'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    BRow, BCol, BCard, BCardText, BButton, BModal, VBModal, BForm, BFormGroup, vSelect, BFormTextarea, flatPickr, BFormInput, BFormRadio, FormWizard, BFormFile, AppTimeline, AppTimelineItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      value: '',
      maxChar: 500,
      item: '',
      rangeDate: null,
      statuses: [
        { id: '3', status: 'Boleto Vencido' },
        { id: '5', status: 'Pedido Recusado' },
        { id: '6', status: 'Abandono de Carrinho' },
        { id: '7', status: 'Entregue' },
        { id: 'select_value', status: 'Select Value' },
      ],
      estados: [
        { id: '1', status: 'AC' },
        { id: '2', status: 'AL' },
        { id: '3', status: 'AP' },
      ],
      categorias: [
        { id: '1', status: 'Calças' },
        { id: '2', status: 'Camisetas' },
        { id: '3', status: 'Camisa' },
      ],
      contact_statuses: '',
      Selected: null,
      estado: null,
      categoria: null,
      groupName: null,
      segmentType: true,
      region: false,
      category: false,
    }
  },
  methods: {
    kFormatter,
  },
}
</script>
  <style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
  </style>
